/**
 * Convierte una URL de imagen a Base64
 * @param {string} path - URL de la imagen
 * @param {string} errorMessage - Mensaje de error opcional
 * @param {Function} reportError - Callback para manejar el mensaje de error
 * @returns {Promise<string>} - Base64 de la imagen
 */
export async function imageToDataUrl(path, errorMessage = '', reportError = () => {}) {
    try {
      const blob = await fetch(path).then((res) => res.blob());
      const reader = new FileReader();
  
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      reportError(errorMessage || 'Error al convertir la imagen a Base64');
      return '';
    }
  }
  
  export const validExtensions = ['.jpg', '.jpeg', '.png'];
  
  export async function processMultimedia(multimedia, reportError) {
    const processedImages = multimedia
       // Filtramos las extensiones y las forzamos a minusculas
      .filter((file) => validExtensions.includes(file.extension.toLowerCase()))
      .map(async (image) => {
        image.base64 = await imageToDataUrl(image.attachment, 'Error procesando la imagen', reportError);
        return image;
      });
  
    return Promise.all(processedImages);
  }